import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface FooterNavigationProps {
  backText?: string;
  backTarget?: string;
  nextText?: string;
  nextTarget?: string;
}

const FooterNavigation: React.FC<FooterNavigationProps> = ({
  backText,
  backTarget,
  nextText,
  nextTarget,
}) => {
    const navigate = useNavigate();

    return (
    <>
        <Box mt={2} display="flex" gap={2}>
        {backText && (
          <Button
            variant="outlined"
            color="success"
            startIcon={<ArrowBackIcon />}
            onClick={() => backTarget && navigate(backTarget)}
          >
            {backText}
          </Button>
        )}
        {nextText && (
          <Button
            variant="contained"
            color="success"
            endIcon={<ArrowForwardIcon />}
            onClick={() => nextTarget && navigate(nextTarget)}
          >
            {nextText}
          </Button>
        )}
        </Box>
    </>
    );
};

export default FooterNavigation;